import moment from 'moment';
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useReactToPrint } from 'react-to-print';
import SvgPdf from '../../../../../../../../assets/icons/Pdf';
import { IReducer } from '../../../../../../../../redux/configureStore';
import { IDefaultButton } from '../../../../../../../../shared/components/buttons/Button/interface';
import DownloadBtn from '../../../../../../../../shared/components/buttons/DownloadButton';
import Pdf from '../../../../../../../../shared/components/Pdf';
import checkValue from '../../../../../../../../utils/values';
import {
  Column,
  Row,
  Table,
  TableContainer,
} from './components/styledComponent';

function ExportPdf(props: IDefaultButton) {
  const apurationData = useSelector(
    (reducer: IReducer) => reducer.apurationAppData
  );
  const partnerListState = useSelector(
    (reducer: IReducer) => reducer.faresFilter
  );
  const partnerList = useSelector(
    (reducer: IReducer) => reducer.clientsApp.partnersList
  );

  const partner = useMemo(() => {
    let value: any = 'Global';
    partnerList.filter((element: any) => {
      const id = element.id.toString();
      if (id === partnerListState.partner) {
        value = element;
      }
      return value;
    });
    return value;
  }, [partnerListState.partner]);

  const componentRef: any = React.useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });
  const numeroContas = [
    apurationData.totalAccountsActives,
    apurationData.totalAccountsPending,
    apurationData.totalAccountsRejected,
    apurationData.totalAccountsBlocked,
    apurationData.totalAccountsFinished,
  ];

  return (
    <div>
      <div style={{ display: 'none' }}>
        <Pdf.Page ref={componentRef}>
          <Pdf.Header>
            <Pdf.Logo />
            <Pdf.Title>Apuração de Contas de Parceiros</Pdf.Title>
          </Pdf.Header>

          <Pdf.Text fontStyle="italic">
            <div>
              Parceiro consultado:
              <Pdf.Text color="#111" fontSize="1rem">
                {partner.razao_social}
              </Pdf.Text>
            </div>
          </Pdf.Text>
          <Pdf.Text fontStyle="italic">
            <div>
              Periodo consultado:
              <Pdf.Text color="#111" fontSize="1rem">
                {moment(partnerListState.initialDate).format('DD/MM/YYYY')} à{' '}
                {moment(partnerListState.finalDate).format('DD/MM/YYYY')}
              </Pdf.Text>
            </div>
          </Pdf.Text>

          <hr />
          <Pdf.Text>Total de contas</Pdf.Text>
          <TableContainer>
            <Table>
              <thead>
                <Row>
                  <Column>Ativas</Column>
                  <Column>Pendentes</Column>
                  <Column>Rejeitadas</Column>
                  <Column>Bloqueadas</Column>
                  <Column>Encerradas</Column>
                  <Column>Total</Column>
                </Row>
              </thead>
              <tbody>
                <Row>
                  <Column>{apurationData.totalAccountsActives}</Column>
                  <Column>{apurationData.totalAccountsPending}</Column>
                  <Column>{apurationData.totalAccountsRejected}</Column>
                  <Column>{apurationData.totalAccountsBlocked}</Column>
                  <Column>{apurationData.totalAccountsFinished}</Column>
                  <Column>
                    {checkValue(
                      numeroContas.reduce((total, n) => {
                        const result = total + n;
                        return result;
                      }, 0)
                    )}
                  </Column>
                </Row>
              </tbody>
            </Table>
          </TableContainer>
          <hr />
          <Pdf.Text>Apuração de Contas Ativas</Pdf.Text>
          <TableContainer>
            <Table>
              <thead>
                <Row>
                  <Column>Tipo de Conta</Column>
                  <Column>Quantidade</Column>
                  <Column>Valor da Tarifa</Column>
                  <Column>Valor a receber</Column>
                </Row>
              </thead>
              <tbody>
                <Row>
                  <Column>Consignada</Column>
                  <Column>{apurationData.consignedQuantity}</Column>
                  <Column>
                    {checkValue(apurationData.consignedFare).toLocaleString(
                      'pt-br',
                      {
                        style: 'currency',
                        currency: 'BRL',
                      }
                    )}
                  </Column>
                  <Column>
                    {checkValue(
                      apurationData.consignedValueToReceive
                    ).toLocaleString('pt-br', {
                      style: 'currency',
                      currency: 'BRL',
                    })}
                  </Column>
                </Row>
              </tbody>
              <tbody>
                <Row>
                  <Column>Escrow</Column>
                  <Column>{apurationData.escrowQuantity}</Column>
                  <Column>
                    {checkValue(apurationData.escrowFare).toLocaleString(
                      'pt-br',
                      {
                        style: 'currency',
                        currency: 'BRL',
                      }
                    )}
                  </Column>
                  <Column>
                    {checkValue(
                      apurationData.escrowValueToReceive
                    ).toLocaleString('pt-br', {
                      style: 'currency',
                      currency: 'BRL',
                    })}
                  </Column>
                </Row>
              </tbody>
              <tbody>
                <Row>
                  <Column>Movimento PF</Column>
                  <Column>{apurationData.pfMovementQuantity}</Column>
                  <Column>
                    {checkValue(apurationData.pfMovementFare).toLocaleString(
                      'pt-br',
                      {
                        style: 'currency',
                        currency: 'BRL',
                      }
                    )}
                  </Column>
                  <Column>
                    {checkValue(
                      apurationData.pfMovementValueToReceive
                    ).toLocaleString('pt-br', {
                      style: 'currency',
                      currency: 'BRL',
                    })}
                  </Column>
                </Row>
              </tbody>
              <tbody>
                <Row>
                  <Column>Movimento PJ</Column>
                  <Column>{apurationData.pjMovementQuantity}</Column>
                  <Column>
                    {checkValue(apurationData.pjMovementFare).toLocaleString(
                      'pt-br',
                      {
                        style: 'currency',
                        currency: 'BRL',
                      }
                    )}
                  </Column>
                  <Column>
                    {checkValue(
                      apurationData.pjMovementValueToReceive
                    ).toLocaleString('pt-br', {
                      style: 'currency',
                      currency: 'BRL',
                    })}
                  </Column>
                </Row>
              </tbody>
            </Table>
          </TableContainer>

          <hr />
          <Pdf.Text>Encerradas Não Tarifadas</Pdf.Text>
          <TableContainer>
            <Table>
              <thead>
                <Row>
                  <Column>Total Encerradas</Column>
                  <Column>Tarifadas</Column>
                  <Column>Não Tarifada</Column>
                </Row>
              </thead>
              <tbody>
                <Row>
                  <Column>{apurationData.totalAccountsFinished}</Column>
                  <Column>{apurationData.activeFares}</Column>
                  <Column>{apurationData.finishedFares}</Column>
                </Row>
              </tbody>
            </Table>
          </TableContainer>
        </Pdf.Page>
      </div>

      <DownloadBtn gridArea={props.gridArea} onClick={handlePrint}>
        <SvgPdf />
      </DownloadBtn>
    </div>
  );
}

export default ExportPdf;
